module.exports = __webpack_public_path__ + "fonts/inter/inter-v20-latin-italic.woff2";